export const colorConstants = {
  AMARELO: { code: '#DEBD3A', color: 'Amarelo' },
  AZUL: { code: '#025AAE', color: 'Azul' },
  LARANJA: { code: '#DE954D', color: 'Laranja' },
  VERDE_1: { code: '#55AB63', color: 'Verde' },
  VERDE_2: { code: '#55A4AB', color: 'Verde Água' },
  VERMELHO: { code: '#C24040', color: 'Vermelho' }
};
